import { watcherSaga as caseSagas } from "modules/case/sagas";
import { watcherSaga as screenerAccessSagas } from "modules/screenerAccess/sagas";
import { all, AllEffect } from "redux-saga/effects";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function* rootSaga(): Generator<AllEffect<any>, void, unknown> {
  yield all([caseSagas(), screenerAccessSagas()]);
}
